export default "__VITE_ASSET__B$0NpXpT__"